import SignIn from './SignIn.component';
import { HeaderSignIn } from './HeaderSignIn.component';
import ResetPassword from './ResetPassword.component';
import ForgotPassword from './ForgotPassword.component';
import ForgotUsername from './ForgotUsername.component';

export default { SignIn, HeaderSignIn, ResetPassword, ForgotPassword, ForgotUsername };
